import React from 'react'
import { memo } from '~/ui/component'
import { Tappable, TappableProps } from '~/ui/components'
import { Label, LabelProps } from './label'

export interface Props extends LabelProps {
  href:   TappableProps['href']
  onTap?: TappableProps['onTap']
}

const LinkLabel = memo('LinkLabel', (props: Props) => {

  const {href, onTap, link = true, flex, ...rest} = props

  return (
    <Tappable href={href} onTap={onTap} flex={flex} noFeedback>
      <Label link={link} {...rest}/>
    </Tappable>
  )

})

export default LinkLabel